/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */


import state from './moduleNotesManagementState.js'
import mutations from './moduleNotesManagementMutations.js'
import actions from './moduleNotesManagementActions.js'
import getters from './moduleNotesManagementGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

